/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EBotExamTranslateStatus } from "../types/EBotExamTranslateStatus.ts";

/**
 * @description 1 = PendingReview | 2 = Reviewed |
 */
export const eBotExamTranslateStatusSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe(
    "1 = PendingReview | 2 = Reviewed | ",
  ) as unknown as ToZod<EBotExamTranslateStatus>;
